// UppyDragDrop
import React, { PropsWithChildren } from 'react';
import styles from './UppyDragDrop.module.sass';
import { DragDrop } from '@uppy/react';
import cn from 'classnames';
import useTrendUppy, { TrendUppyProps } from 'hooks/useTrendUppy';

export interface UppyDragDropProps extends PropsWithChildren {
  uppyProps: TrendUppyProps;
  containerClassName?: string;
  copy?: Record<'dropHereOr' | 'browse', string>;
}

const UppyDragDrop: React.FC<UppyDragDropProps> = ({
  uppyProps,
  containerClassName = styles.default,
  copy = {
    dropHereOr: '%{browse} or drag & drop your content',
    browse: 'Click here',
  },
  children,
}) => {
  const uppy = useTrendUppy('UppyDragDrop', uppyProps);

  return (
    <div className={cn(styles.uppyDragDrop, containerClassName)}>
      <DragDrop
        width="100%"
        height="100%"
        uppy={uppy}
        locale={{ strings: copy }}
      />
      <style jsx global>{`
        .uppy-DragDrop-arrow {
          display: none;
        }
      `}</style>
      {children}
    </div>
  );
};

export default UppyDragDrop;
